import { CdnContext } from '@/contexts/CdnContext';
import { GameType as GameTypeEnum } from '@/models/games/enums/GameType';
import { getLocaleByCode } from '@/models/Locale';
import { ROUTE_GAME, ROUTE_ROOT } from '@/models/Route';
import { getHostById } from '@/modules/host/slice';
import { getMainUserState } from '@/modules/main/selector';
import { userSliceActions } from '@/modules/main/slice/user';
import { RootState } from '@/store/store';
import { Box } from '@mui/material';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CancelButton } from '../svg';
import './index.scss';

const gameTypeKey: Map<string, string> = new Map([
    [GameTypeEnum.Baccarat.toString(), 'baccarat'],
    [GameTypeEnum.AndarBahar.toString(), 'andar-bahar'],
    [GameTypeEnum.Blackjack.toString(), 'blackjack'],
    [GameTypeEnum.Blackjack2.toString(), 'blackjack'],
    [GameTypeEnum.Dragon.toString(), 'dragon-tiger'],
    [GameTypeEnum.PokDeng.toString(), 'pok-deng'],
    [GameTypeEnum.Roulette.toString(), 'roulette'],
    [GameTypeEnum.SicBo.toString(), 'sic-bo'],
    [GameTypeEnum.TeenPatti2020.toString(), 'teen-patti-20-20'],
    [GameTypeEnum.ThaiHiLo.toString(), 'thai-hilo'],
    [GameTypeEnum.SeDie.toString(), 'xoc-dia'],
    [GameTypeEnum.FishPrawnCrab.toString(), 'fish-prawn-crab'],
]);
export const PayoutPopup = () => {
    const [hostId, setHostID] = useState<number>(0);
    const location = useLocation();
    const dispatch = useDispatch();
    const { showPayoutTable } = useSelector(getMainUserState);
    const [openPopup, setOpenPopup] = useState<boolean>(false);
    const { gameRuleUrl } = useContext(CdnContext);
    const { i18n } = useTranslation();
    const { GameType } = useSelector((state: RootState) =>
        getHostById(state, hostId)
    );
    const currentCode = i18n.language;
    const gameRuleLanguage = getLocaleByCode('long', currentCode).short;
    const displayUrl = useMemo(() => {
        if (location.pathname.indexOf(ROUTE_GAME) >= 0 && !GameType) {
            return undefined;
        }
        let key = GameType ? gameTypeKey.get(GameType.toString()) : '';
        return `${gameRuleUrl}payout/#${key}`;
    }, [gameRuleUrl, gameRuleLanguage, GameType]);

    useEffect(() => {
        if (hostId == 0 && location.pathname.indexOf(ROUTE_GAME) >= 0) {
            const host = location.pathname.substring(
                location.pathname.lastIndexOf('/') + 1
            );
            setHostID(Number(host));
        }
    }, [location]);
    useEffect(() => {
        if (location.pathname !== ROUTE_ROOT && showPayoutTable && displayUrl) {
            setOpenPopup(true);
        }
    }, [location, showPayoutTable, displayUrl]);
    const changeOpen = (b: boolean) => {
        setOpenPopup(b);
        if (!b) {
            dispatch(userSliceActions.updateShowPayoutTable(false));
        }
    };
    return openPopup ? (
        <Box className="payout-container">
            <div className="payout-inner-container">
                <CancelButton
                    width={'2.25rem'}
                    height={'2.25rem'}
                    onClick={() => {
                        changeOpen(false);
                    }}
                />
                <iframe className="payout-iframe" src={displayUrl} />
            </div>
        </Box>
    ) : (
        <></>
    );
};
